module.exports = __webpack_public_path__ + "img/kwaiMeDownload3.caf14f9.png";